import * as types from "../constants";
import baseUrl from "../../config/ipConfig";



export const fetchVideos = (query) => async (dispatch) => {
  //set loading to true
  dispatch({
      type: types.FETCHING_VIDEOS
  })


  //fetch video
  try {
    const res = await fetch(baseUrl + "/v1/videos" + query);
    const data = await res.json();

    //data success
    return dispatch({
        type: types.FETCH_VIDEOS_SUCCESS,
        payload: data.videos
    });
  } catch (error) {
      console.log(error.message);
      return dispatch({
          type: types.FETCH_VIDEOS_FAILURE,
          payload: error
      })
  }
};
